export const useFacilityCollections = defineStore('facilityCollections', {
  state: () => ({
    collections: [],
    selectedCollection: null,
    selectedFacility: null,
  }),
  actions: {
    setCollections(collections) {
      this.collections = collections;
    },
    setSelectedCollection(collection) {
      this.selectedCollection = collection;
    },
    setSelectedFacility(facility) {
      this.selectedFacility = facility;
    },
    clearSelectedFacility() {
      this.selectedFacility = null;
    }
  },
  getters: {
    getAllFacilities: (state) => state.collections.flatMap(collection => collection.facilities),
  }
});
